// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Gp-z","breadcrumbForward":"Hp-z","breadcrumbBack":"Ip-z","selected":"Jp-z"};